import classNames from "classnames";
import type { ComponentPropsWithRef } from "react";
import { Progress as ProgressBase } from "@base-ui/react/progress";
import styles from "./ProgressBar.module.scss";

export const ProgressRoot = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof ProgressBase.Root>) => (
    <ProgressBase.Root
        className={classNames(styles.root, className)}
        {...props}
    />
);

export const ProgressValue = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof ProgressBase.Value>) => (
    <ProgressBase.Value
        className={classNames(styles.value, className)}
        {...props}
    />
);

export const ProgressTrack = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof ProgressBase.Track>) => (
    <ProgressBase.Track
        className={classNames(styles.track, className)}
        {...props}
    />
);

export const ProgressIndicator = ({
    className,
    ...props
}: ComponentPropsWithRef<typeof ProgressBase.Indicator>) => (
    <ProgressBase.Indicator
        className={classNames(styles.indicator, className)}
        {...props}
    />
);
